import React from 'react';
import { PlusOutlined } from '@ant-design/icons';

export const UploadButton = () => {
    return (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Загрузить</div>
        </div>
    );
};
